<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Multi Tracking" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                    //- button.btn-primary-o(@click="back()")
                    router-link.btn-default(to="/multi-tracking")
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg> 
                        span.mr-1 Back
            .box__body
                .container-form(action="" method="method")
                    section.group-fields.border-b
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="group_name") Group Name *
                            .field__form
                                input.field-style(id="group_name" name="group_name" type="text" placeholder="Group Name" v-model="group_name" maxlength="255")
                                .error.pt-1.text-xs.mr-2(v-if="error_group_name !== null") {{ error_group_name }}
                            
                        //- colors
                        //- .field.flex.items-center.w-full.-mx-4.mb-6
                        //-     div.px-4(class="w-1/3").text-right
                        //-         label.block.text-sm.font-bold.mb-2(for="label") Label Color *
                        //-     div.px-4(class="w-2/3")
                        //-         ul.flex.items-center(name="label" v-model="label")
                        //-             li.mr-2(v-for="opt in labelOpt" :key="opt.key" :value="opt.key" @click="selectLabel(opt.key)")
                        //-                 div.box-label.p-1.border.rounded-full(:class="label === opt.key ? 'border-white-900':'border-gray-200'")
                        //-                     label(:class="[`block w-6 h-6 bg-${opt.key}-500 rounded-full`]")
                        //-     .error(v-if="error_label !== null") {{ error_label }}
                        
                        //- case name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="case_id") Operation Name *
                            .field__form
                                .relative(v-if="load_data_status_case_management_list === 'loading'")
                                    .field-style.flex.flex-wrap.items-center.justify-center.p-2
                                        Spinner(show="true" size="32")
                                .relative(v-else)
                                    multiselect(
                                        v-if="case_management_list.data && case_management_list.data.length > 0"
                                        :value="completeValue",
                                        :options="case_management_list.data ? case_management_list.data : []",
                                        :multiple="true",
                                        placeholder="Select Case",
                                        label="operation_name",
                                        track-by="id",
                                        @input="onChange"
                                    )

                                    .field.field--disabled(v-else)
                                        input.field-style(type="text" placeholder="Case empty" disabled)
                                .error.pt-1.text-xs.mr-2(v-if="error_case_id !== null") {{ error_case_id }}
                                                                    
                    //-===== end section
                        
                    //- section target clues
                    section.group-fields.border-b
                        //- name
                        .field
                            .field__label
                                //- label.block.text-sm.font-bold.mb-2.pt-2(for="field") Search Target
                                label.block.text-sm.font-bold.mb-2.pt-2(for="field") Select Target
                            .field__form
                                //- search field
                                .relative.field--search.w-full(:class="case_id.length>0?'':'field--disabled'")
                                    input.field-style#find-target-input(:disabled="case_id.length > 0?false:'disabled'" type="text" v-bind:placeholder="case_id.length > 0 ?'Search target here (write min 3 characters)' : 'Please select Operation Name first'" v-model="target_keyword" @keyup="searchTarget()")
                                    .absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                //- .field.relative.field--search.w-full(:class="case_id.length>0?'':'field--disabled'")
                                //- .pt-1(v-if="case_id.length <= 0") No target yet.
                                    //- input.field-style#find-target-input(:disabled="case_id.length > 0?false:'disabled'" type="text" v-bind:placeholder="case_id.length > 0 ?'Search target here (write min 3 characters)' : 'Please select Operation Name first'" v-model="target_keyword" @keyup="searchTarget()")
                                    //- .absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                
                                .flex.items-center.w-full.mb-4.mt-4.justify-center(v-if="load_data_status_single_target_list.status === 'loading' && next_page === false")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")

                                //- IF THE TARGET FOUND
                                //- .block.pt-4
                                    .flex.items-center.w-full.mb-2.mt-4
                                        span.text-xs.uppercase.text-gray-600.font-bold Choose a target
                                    .flex.items-center.w-full.mb-4
                                        .target-lists.block.w-full
                                            ul
                                                li.flex.items-center.justify-between.border-b.p-4(
                                                    class="hover:bg-gray-100"
                                                    style="cursor: pointer;"
                                                )
                                                    .flex.items-center
                                                        figure.w-6.h-6.mr-4
                                                            img.w-full.h-full.object-cover.rounded-full.bg-gray-100(src="https://randomuser.me/api/portraits/women/33.jpg")
                                                        span.text-gray-600.name-index Layla Phillips
                                                        span.text-gray-600.name-index 093284593485
                                                //- li.flex.items-center.justify-between.border-b.p-4(
                                                //-     class="hover:bg-gray-100"
                                                //-     style="cursor: pointer;"
                                                //- )
                                                //-     .flex.items-center
                                                //-         figure.w-6.h-6.mr-4
                                                //-             img.w-full.h-full.object-cover.rounded-full.bg-gray-100(src="https://randomuser.me/api/portraits/women/33.jpg")
                                                //-         span.text-gray-600.name-index Layla Phillips
                                //- END THE TARGET FOUND

                                //- template(v-else-if="single_target_list.data && single_target_list.data.length > 0")
                                template(v-else-if="single_target_list_data.length > 0")
                                    .mb-4.pt-2
                                        span.text-xs.uppercase.font-bold Choose a target
                                    .target-lists.main-target-lists.block.w-full
                                        //- .relative
                                            input.field-style#find-target-input(:disabled="case_id.length > 0?false:'disabled'" type="text" v-bind:placeholder="case_id.length > 0 ?'Search target here (write min 3 characters)' : 'Please select Operation Name first'" v-model="target_keyword" @keyup="searchTarget()")
                                            //- input.field-style(placeholder="Search target here (write min 3 characters)")
                                            .absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                        ul
                                            li.flex.items-center.justify-between.border-b.p-4(
                                                style="cursor: pointer;"
                                                v-tooltip="'Choose this target'"
                                                v-for="(target,index) in single_target_list_data"
                                                :key="target.id"
                                                @click="addTarget(target)"
                                            )
                                                .mr-2
                                                    .block(:class="[`w-4 h-4 rounded-full`]" :style="'background-color: '+ target.label +';'")
                                                .flex.items-center.flex-grow
                                                    figure.w-6.h-6.mr-4
                                                        img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target.photo ? target.photo : ImgAvatar" @error="getDefaultImage")
                                                    span {{ target.target_name }}
                                                    //- label(:class="[`inline-block bg-${target.label}-500 w-4 h-4 rounded-full`]")

                                            li.text-center.border-b.p-4.text-small(v-if="total_page === page")
                                                | No more data avaliable.

                                            template(v-else)
                                                li.p-4.text-center
                                                    .flex.flex-wrap.items-center.justify-center(v-if="load_data_status_single_target_list.status === 'loading' && next_page === true")
                                                        Spinner(show="true" size="32")
                                                    button.btn.btn-primary-o.btn-small(v-else type="button" @click="searchTarget(true)") Load more...

                                .flex.items-center.w-full.mb-4.mt-2(v-else-if="single_target_list.data && single_target_list.data.length == 0")
                                    span.text-md
                                        | No data available.


                                //- IF THE TARGET NOT FOUND
                                .block.pt-4(v-else-if="single_target_list.data && single_target_list.data.length == 0")
                                    .text-xs.mb-2
                                        .uppercase.text-gray-600.font-bold Target not found
                                        //- p Please check the spelling or you can add new target

                                    .flex.items-center.w-full.mb-1.hidden
                                        input.field-style(type="text" placeholder="Target Name, Ex: 'Harry Parker'" v-model="create_target_name" v-on:keyup.enter="createTarget()")
                                        input.field-style.ml-2(type="number" placeholder="MSISDN 1, Ex: '081234567890'" v-model="create_target_msisdn_1" v-on:keyup.enter="createTarget()" min="0")
                                        input.field-style.ml-2(type="number" placeholder="MSISDN 2, Ex: '081234567890'" v-model="create_target_msisdn_2" v-on:keyup.enter="createTarget()")
                                        input.field-style.ml-2(type="number" placeholder="MSISDN 3, Ex: '081234567890'" v-model="create_target_msisdn_3" v-on:keyup.enter="createTarget()")

                                        //- input.field-style.ml-2(v-if="create_target_msisdn_1.length > 0" type="number" placeholder="MSISDN 2, Ex: '081234567890'" v-model="create_target_msisdn_2" v-on:keyup.enter="createTarget()" min="0")
                                        //- input.field--disabled.field-style.ml-2(v-else type="number" disabled="disabled" placeholder="MSISDN 2, Ex: '081234567890'")

                                        //- input.field-style.ml-2(v-if="create_target_msisdn_2.length > 0" type="number" placeholder="MSISDN 3, Ex: '081234567890'" v-model="create_target_msisdn_3" v-on:keyup.enter="createTarget()" min="0")
                                        //- input.field--disabled.field-style.ml-2(v-else type="number" disabled="disabled" placeholder="MSISDN 3, Ex: '081234567890'")

                                        button.btn-small.btn-primary-o.ml-2(type='button' @click="createTarget()")
                                            div
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                //- END IF THE TARGET NOT FOUND

                                //- .flex.items-center.w-full.mb-4(v-if="clues.length > 0")
                                    span.text-xs.uppercase.text-gray-600.font-bold Added Clues
                                //- .flex.items-center.w-full.mb-4(v-for="(clue, index) in clues" :key="index")
                                    div(class="w-1/3")
                                        .relative
                                            select.field-style(v-model="clue.name" :key="index")
                                                option(v-for="opt in cluesOpt" :value="opt.key" :selected="opt.key === clue.name ? 'selected' : ''") {{ opt.name }}
                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                    div.flex.pl-2(class="w-2/3")
                                        input.field-style(type="text" placeholder="Write Target's clue" v-model="clue.value" :key="index")
                                        //- input.field-style(type="text" placeholder="Write Target's clue" v-model="clues[index].value")
                                        button.btn-small.btn-default.ml-2(type='button' @click="deleteClue(index)")
                                            div.text-gray-500
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        
                    //-===== end section

                    //- section territory target choosen
                    section.group-fields.border-b
                        //- name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2.pt-2(for="field") Target Choosen *
                            .field__form
                                .choosen-target
                                    template(v-if="target_choosen.length > 0")
                                        .box--items.rounded.mb-4(
                                            v-for="(target, index) in target_choosen"
                                            :keys="index"
                                        )
                                            .flex.items-center.justify-between.border-b.p-4
                                                .flex.items-center.flex-grow
                                                    .mr-2
                                                        .block(:class="[`w-4 h-4 rounded-full`]" :style="'background-color: '+ target.label +';'")
                                                    .flex.items-center
                                                        figure.w-6.h-6.mr-4
                                                            img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target.photo ? target.photo : getDefaultImage" @error="getDefaultImage")
                                                        span.text-light(v-if="target.id.length > 0") {{ target.target_name }}

                                                        input.field-style(v-else type="text" placeholder="Target Name, Ex: 'Harry Parker'" :value="target.target_name" @keyup="updateCreateTarget($event, index, true)")
                                                button.btn-icon.btn-icon-40
                                                    .icon-btn
                                                        <svg v-tooltip="'Remove Target'" @click="removeTarget(index)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>

                                            //- template(v-if="target.msisdn.length > 0")
                                            .clues.flex.items-center.p-4
                                                template(v-if="target.id.length > 0")
                                                    .block(class="w-full lg:w-1/3 mb-3 lg:mb-0" v-for="(target_msisdn, index) in target.msisdn" :key="index")
                                                        .wrapper-checkbox
                                                            input(type="checkbox" v-model="target_checked" :value="target.id + '_' + target_msisdn" @change="checkTargetMsisdn($event, target.id, target_msisdn)")
                                                            .ui-checkbox.flex.items-center
                                                                .checkbox.flex.items-center.justify-center
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                strong {{ target_msisdn }}
                                                                //- strong hmm

                                                .flex.items-center.justify-between.mb-1(v-else)
                                                    input.field-style(type="number" placeholder="MSISDN 3, Ex: '081234567890'" :value="target_choosen[index].msisdn[0]" @keyup="updateCreateTarget($event, index, null, true, 0)" min="0")
                                                    input.field-style.ml-2(type="number" placeholder="MSISDN 3, Ex: '081234567890'" :value="target_choosen[index].msisdn[1]" @keyup="updateCreateTarget($event, index, null, true, 1)" min="0")
                                                    input.field-style.ml-2(type="number" placeholder="MSISDN 3, Ex: '081234567890'" :value="target_choosen[index].msisdn[2]" @keyup="updateCreateTarget($event, index, null, true, 2)" min="0")

                                                    //- input.field-style.ml-2(v-if="target_choosen[index].msisdn[0] && target_choosen[index].msisdn[0].length > 0" type="number" placeholder="MSISDN 3, Ex: '081234567890'" :value="target_choosen[index].msisdn[1]" @keyup="updateCreateTarget($event, index, null, true, 1)" min="0")
                                                    //- input.field--disabled.field-style.ml-2(v-else type="number" disabled="disabled" placeholder="MSISDN 2, Ex: '081234567890'")

                                                    //- input.field-style.ml-2(v-if="target_choosen[index].msisdn[1] && target_choosen[index].msisdn[1].length > 0" type="number" placeholder="MSISDN 3, Ex: '081234567890'" :value="target_choosen[index].msisdn[2]" @keyup="updateCreateTarget($event, index, null, true, 2)" min="0")
                                                    //- input.field--disabled.field-style.ml-2(v-else type="number" disabled="disabled" placeholder="MSISDN 3, Ex: '081234567890'")
                                    
                                    //- .mb-6(v-else) -
                                    div(v-else)
                                        .pt-2 Please choose the target from target list
                                    .error(v-if="error_target !== null") {{ error_target }}
                    //-===== end section

                    //- section Additional info
                    section.group-fields.border-b(v-if="isAstro !== 'true'")
                        //- name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2.pt-2(for="field") Additional Information
                            .field__form
                                .flex.items-end.w-full.mb-1(
                                    class="flex-col lg:flex-row lg:items-center"
                                )
                                    .w-full(class="lg:w-1/3")
                                        .relative(
                                            class="mb-2 lg:mb-0"
                                        )
                                            input.field-style(
                                                id="info-name-tmp"
                                                type="text"
                                                placeholder="Write a Key"
                                                name="info-name-tmp"
                                                v-model="infoNameTmp"
                                                v-on:keyup.enter="addInfo()"
                                            )
                                    .flex.pl-0.pb-2(
                                        class="lg:w-2/3 w-full lg:pl-2 flex-col lg:flex-row lg:pb-0"
                                    )
                                        input.field-style(
                                            id="info-val-name"
                                            type="text"
                                            placeholder="Write a Key's value"
                                            v-model="infoValTmp"
                                            v-on:keyup.enter="addInfo()"
                                            class="mb-2 lg:mb-0"
                                        )
                                        .flex.ml-0.mt-4.justify-end(
                                            class="lg:ml-4 lg:mt-0"
                                        )
                                            button.btn-icon.btn-icon-40.btn-primary-o(
                                                    type='button'
                                                    @click="addInfo()"
                                            )
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                .w-full(v-if="additional_info.length > 0")
                                    .text-xs.uppercase.font-bold.py-4 Added Additional Information
                                    .box--items
                                        .flex.items-center.w-full.py-4.px-2.border-b.is-item.is-item--keys(
                                            v-for="(info, index) in additional_info"
                                            :key="index"
                                            class="flex-col lg:flex-row"
                                        )
                                            .relative(
                                                    class="lg:mr-2 mr-0 w-full"
                                                )
                                                input.field-style(v-model="info.name" :key="index" type="text" placeholder="Write")
                                            input.field-style(v-model="info.value" :key="index" type="text" placeholder="Write")
                                            button.btn-icon.ml-2(type='button' @click="deleteInfo(index)")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                    
                        
                    //-===== end section

                    //- section target spesifict
                    section.group-fields.border-b
                        //- name
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="description") Description
                            .field__form
                                textarea.field-style(id="description" name="description" v-model="description" style="min-height: 200px;" placeholder="Write Target's Description")
                                .error(v-if="error_description !== null") {{ error_description }}

                    //-===== end section
                    .flex.items-center.justify-end.mb-8
                        //- button.btn-primary-o.mr-3 DRAFT
                        //- button.btn-primary SAVE
                        button.btn-default.btn-large.mr-3(type='button' @click="reset()")
                            Strong Reset
                        button.btn-primary-o.btn-large.mr-3(type='submit' @click="submit($event, true)")
                            Strong Save &amp; Continue
                        button.btn-primary.btn-large(type='submit' @click="submit")
                            Strong Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import Multiselect from 'vue-multiselect'
// import { encrypt } from '@/util/crypto'
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'PageMultiTrackingForm',
    components: {
        HeaderGlobal,
        Multiselect,
        Spinner,
    },
    data: function() {
        return {
            value: null,
            options: ['list', 'of', 'options'],
            group_name: '',
            // target: '',
            // clues: [],
            // label: '',
            // status: '',
            // photo: '',
            case_id: [],
            additional_info: [],
            description: '',
            //tmp
            // photoFile: '',
            clueNameTmp: '',
            clueValTmp: '',
            infoNameTmp: '',
            infoValTmp: '',

            // error field
            error_group_name: '',
            // error_clues: '',
            // error_label: '',
            // error_status: '',
            // error_photo: '',
            error_case_id: '',
            error_target: '',
            error_additional_info: '',
            error_description: '',

            imgAvatar: require('../../assets/no-image-profile.jpg'),

            labelOpt: [
                {key: 'green'},
                {key: 'red'},
                {key: 'purple'},
                {key: 'orange'},
                {key: 'blue'},
            ],
            // cluesOpt: [
            //     {key: 'msisdn',name: 'MSISDN'},
            //     {key: 'nik',name: 'NIK'},
            //     {key: 'imsi',name: 'IMSI'},
            //     {key: 'imei-sv',name: 'IMEI-SV'},
            //     {key: 'nopol',name: 'Plat Nomor'},
            // ],

            // target: [],
            target: '',
            target_checked: [],

            target_keyword: '',
            target_choosen: [],
            timeout: null,

            create_target_name: '',
            create_target_msisdn_1: '',
            create_target_msisdn_2: '',
            create_target_msisdn_3: '',

            isAstro: process.env.VUE_APP_ASTRO,

            // pagination for target from case management / operation name
            single_target_list_data: [],
            page: 1,
            total_page: null,
            next_page: false,
        }
    },
    computed: {
        ...mapState([
            'multi_tracking_detail',
            'load_data_status_case_management_list',
            'case_management_list',
            'multi_tracking_redirect',
            // 'auth_data',
            'load_data_status_single_target_list',
            'single_target_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit Multi Tracking',
                url: '/multi-tracking/'+this.id+'/edit',
            };
            if (this.route_name === 'PageMultiTrackingCreate')
                page = {
                    name: 'Add Multi Tracking',
                    url: '/multi-tracking/create',
                };

            return [
                {
                    name: 'Multi Tracking',
                    url: '/multi-tracking',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit Multi Tracking';
            if (this.route_name === 'PageMultiTrackingCreate')
                title = 'Add Multi Tracking';
            return title;
        },
        completeValue: {
            get() {
                if (!this.case_id) return null
                // console.log('=====onChange:get')
                // console.log(this.case_id)
                try {
                    return this.case_id.map(value => this.findOption(value.id)).filter(value => value.id)
                } catch (error) {
                    return null
                }
            },
            set(v) {
                // console.log('=====completeValue:set')
                // console.log(v)
                this.case_id=v.map(value => {
                    let rObj = {}
                    rObj['id'] = value.id
                    return rObj
                })
            }
        },
    },
    watch: {
        route_name() {
            this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
            this.getData();
        },
        id() {},
        breadcrumb() {},
        page_title() {},
        // form data
        multi_tracking_detail(newData) {
            // console.log(newData)

            this.group_name = (newData.group_name ? newData.group_name : '');
            // this.clues = (newData.clues ? newData.clues : []);
            // this.label = (newData.label ? newData.label : '');
            // this.status = (newData.status ? (newData.status.toLowerCase() === 'start' ? '1' : '0') : '');
            // this.photo = (newData.photo ? newData.photo : '');
            this.case_id = (newData.cases && newData.cases ? newData.cases : []);

            if (newData.target && newData.target.length > 0) {
                // console.log('newData.target.length')
                // console.log(newData.target.length)
                this.target_choosen = newData.target;

                let target_checked = [];
                for (var i = 0; i < newData.target.length; i++) {
                    // console.log(newData.target[i]);
                    for (var j = 0; j < newData.target[i].msisdn.length; j++) {
                        // console.log(newData.target[i][j]);
                        // console.log('newData.target[i].msisdn.length')
                        // console.log(newData.target[i].msisdn.length)
                        target_checked.push(newData.target[i].id + '_' + newData.target[i].msisdn[j])
                    }
                }

                // console.log(target_checked);
                this.target_checked = target_checked;
            }

            this.additional_info = (newData.additional_info ? newData.additional_info : []);
            this.description = (newData.description ? newData.description : '');
            // console.log(newData.cases.length)
            if(newData.cases && newData.cases.length>0){
                // console.log('newData.cases.length')
                // console.log(newData.cases.length)
                // console.log('hulalalala')
                this.searchTarget();
            }
        },

        group_name() {},
        // clues() {},
        // load_data_status_case_management_list(newData) {
        //     if (newData === 'loading') {
        //         this.showLoading(true);
        //     } else {
        //         this.showLoading(false);
        //     }

        // },
        case_id() {},
        // status() {},
        additional_info() {},


        // ------------------------------------------------
        // get target list from case
        single_target_list(newData) {
            if (newData.data && newData.data.length > 0) {
                // console.log(newData.data.length)
                this.page = parseInt(newData.current_page);
                this.total_page = parseInt(newData.total_page);

                for (var i = 0; i < newData.data.length; i++) {
                    this.single_target_list_data.push(newData.data[i]);
                }
            }

        },
        target_keyword(newData) {
            if (newData.length < 3)
                this.$store.commit('setSingleTargetList', {});
        },
        target_choosen(newData) {
            // console.log('watch target_choosen');
            // console.log(newData);
            let target = newData;

            if (Object.keys(target).length > 0) {
                target = target.map(function(item) {
                    let target = {
                        id: item.id,
                        name: item.target_name,
                        label: item.label,
                        msisdn: item.msisdn,
                    };
                    // return item;
                    return target;
                });
                // console.log(target);
            }
            
            this.target = JSON.stringify(target);
            // this.target = target;
            // console.log(this.target);
        },
    },
    methods: {
        back(){
            // if (this.multi_tracking_redirect !== 'index') {
            //     var msisdn = this.checkMsisdn(this.clues)
            //     if (msisdn.length > 0) {
            //         this.$router.push({ name: 'PageMultiTrackingDetailHome', params: { id: this.id ,key: encrypt(msisdn[0].value + '&&msisdn') }  })
            //     } else {
            //         this.$router.push('/multi-tracking');
            //     }
            // } else {
                this.$router.push('/multi-tracking');
            // }
        },
        checkMsisdn(data) {
            var msisdn = data.filter(function (clue) {
                return clue.name === 'msisdn'
            })
            return msisdn
        },
        onChange(value) {
            // console.log('this.completeValue.length')
            // console.log(this.completeValue)
            // console.log('value.length')
            // console.log(value)
            // check case dihapus
            if (this.completeValue.length > value.length) {           
                // check target
                var delTarget = []
                for (var i = 0; i < this.target_choosen.length; i++) {
                    var isDelete = true
                    // console.log('this.target_choosen[i]')
                    // console.log(this.target_choosen[i])
                    var cases = this.target_choosen[i].cases
                    if (typeof(cases) != 'undefined' && cases.length > 0) {                    
                        for (var j = 0; j < cases.length; j++) {
                            for (var k = 0; k < value.length; k++) {
                                if(cases[j].id == value[k].id)
                                    isDelete = false
                            }
                        }
                    } else {
                        isDelete = false            
                    }
                    // console.log('checkAkhir')
                    // console.log(this.target_choosen[i].target_name)
                    // console.log(isDelete)
                    // console.log(i)
                    if (isDelete) {
                        delTarget.push(i)
                        let target_remove = this.target_choosen[i];
                        for (var l = 0; l < target_remove.msisdn.length; l++) {
                            let index_checked = null;
                            let search_checked = this.target_checked.filter(function(item, i) {
                                if (item === target_remove.id + '_' + target_remove.msisdn[l]) {
                                    index_checked = i;
                                    return item;
                                }
                            });

                            if (search_checked.length > 0 && index_checked !== null) {
                                this.target_checked.splice(index_checked, 1);
                            }
                        }
                    }
                }
                for (var m = delTarget.length -1; m >= 0; m--)
                    this.target_choosen.splice(delTarget[m],1);
            }
            this.completeValue = value
            // target_choosen

            // console.log('this.completeValue')
            // console.log(this.completeValue)
            // console.log(this.completeValue.length)
            if (this.completeValue.length > 0) {
                this.searchTarget();
            } else {
                this.$store.commit('setSingleTargetList', {});
                this.single_target_list_data = [];
                this.page = 1;
                this.total_page = null;
                this.next_page = false;
            }
        },
        findOption(value) {
            // console.log('=====findOption')
            // console.log(value)
            const opt = this.case_management_list.data
            return opt.find(option => option['id'] === value)
        },
        getDefaultImage(e) {
            e.target.src = this.imgAvatar;
        },

        searchTarget(nextPage=false) {
                // clear timeout variable
                clearTimeout(this.timeout);

                var self = this;
                this.timeout = setTimeout(function () {
                    // if (self.target_keyword.length > 2) {
                        self.$store.commit('setSingleTargetList', {});
                        if (nextPage === false) {
                            self.single_target_list_data = [];
                            self.page = 1;
                            self.total_page = null;
                            self.next_page = false;
                        } else {
                            self.next_page = true;
                        }
                        // no_case_or_cases
                        var no_case_or_cases = []
                        for (var i = 0; i < Object.keys(self.case_id).length; i++) {
                            no_case_or_cases.push(self.case_id[i].id)
                        }
                        // console.log(no_case_or_cases)
                        // self.$store.dispatch('getSingleTargetList', [30, 1, self.target_keyword,null, null, null, null, JSON.stringify(no_case_or_cases)]);
                        self.$store.dispatch('getSingleTargetList', [10, (nextPage === false ? self.page : (self.page + 1)), self.target_keyword, null, null, null, null, JSON.stringify(no_case_or_cases)]);
                    // }
                }, 650);
        },
        createTarget() {

            if (process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT && Number.isInteger(parseInt(process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT))) {
                if (this.target_choosen.length >= parseInt(process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT)) {
                    this.error('Max target allowed is '+ process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT + '!');
                    return;
                }
            }

            if (this.create_target_name.length === 0 || (this.create_target_msisdn_1.length === 0 && this.create_target_msisdn_2.length === 0 && this.create_target_msisdn_3.length === 0)) {
                this.error("Target Name & MSISDN is required!");
                return;
            }

            let target = {
                id: '',
                target_name: this.create_target_name,
                label: this.labelOpt[Math.floor(Math.random() * 5)].key,
                photo: '',
                // msisdn: [this.create_target_msisdn_1], // for map msisdn[]
                msisdn: [], // for map msisdn[]
                cases: [], // for map msisdn[]
            };

            if (this.create_target_msisdn_1 && this.create_target_msisdn_1.length > 0)
                target.msisdn.push(this.create_target_msisdn_1);

            if (this.create_target_msisdn_2 && this.create_target_msisdn_2.length > 0)
                target.msisdn.push(this.create_target_msisdn_2);

            if (this.create_target_msisdn_3 && this.create_target_msisdn_3.length > 0)
                target.msisdn.push(this.create_target_msisdn_3);

            this.target_choosen.push(target);

            this.target_keyword = '';
            this.create_target_name = '';
            this.create_target_msisdn_1 = '';
            this.create_target_msisdn_2 = '';
            this.create_target_msisdn_3 = '';
        },
        updateCreateTarget(e, index, name=false, msisdn=false, index_msisdn=null) {

            clearTimeout(this.timeout);

            var self = this;
            this.timeout = setTimeout(function () {
                // console.log(e.target.value)

                if (name === true) {
                    self.target_choosen[index].target_name = e.target.value;
                    // console.log(self.target_choosen[index])
                }

                if (msisdn === true && index_msisdn !== null) {

                    if (e.target.value === '') {
                        if (index_msisdn === 0 || index_msisdn === '0') {
                            if ((!self.target_choosen[index].msisdn[1] || self.target_choosen[index].msisdn[1] === '') && (!self.target_choosen[index].msisdn[2] || self.target_choosen[index].msisdn[2] === '')) {
                                e.target.value = self.target_choosen[index].msisdn[index_msisdn];
                                self.error("MSISDN is required for target "+ self.target_choosen[index].target_name +"!");
                                return;
                            }
                        } else if (index_msisdn === 1 || index_msisdn === '1') {
                            if ((!self.target_choosen[index].msisdn[0] || self.target_choosen[index].msisdn[0] === '') && (!self.target_choosen[index].msisdn[2] || self.target_choosen[index].msisdn[2] === '')) {
                                e.target.value = self.target_choosen[index].msisdn[index_msisdn];
                                self.error("MSISDN is required for target "+ self.target_choosen[index].target_name +"!");
                                return;
                            }
                        } else if (index_msisdn === 2 || index_msisdn === '2') {
                            if ((!self.target_choosen[index].msisdn[0] || self.target_choosen[index].msisdn[0] === '') && (!self.target_choosen[index].msisdn[1] || self.target_choosen[index].msisdn[1] === '')) {
                                e.target.value = self.target_choosen[index].msisdn[index_msisdn];
                                self.error("MSISDN is required for target "+ self.target_choosen[index].target_name +"!");
                                return;
                            }
                        }
                    }

                    self.target_choosen[index].msisdn[index_msisdn] = e.target.value;
                    // console.log(self.target_choosen[index])
                }

                // self.target_choosen = target_choosen;

            }, 10);
        },
        addTarget(target) {

            if (process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT && Number.isInteger(parseInt(process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT))) {
                if (this.target_choosen.length >= parseInt(process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT)) {
                    this.error('Max target allowed is '+ process.env.VUE_APP_MULTI_TRACKING_TARGET_LIMIT + '!');
                    return;
                }
            }

            target = {
                id: target.id,
                target_name: target.target_name,
                label: target.label,
                photo: target.photo,
                msisdn: target.clues, // for map msisdn[]
                cases: target.cases,
            };
            // console.log(target);

            if (target.msisdn.length > 0) {
                // console.log(target.msisdn);

                let search_msisdn = target.msisdn;
                search_msisdn = search_msisdn.filter(function(item) {
                    if (item.name === 'msisdn')
                        return item;
                });
                search_msisdn = Object.keys(search_msisdn).map((key) => search_msisdn[key].value);

                if (search_msisdn.length > 0) {

                    target.msisdn = search_msisdn;

                    if (this.target_choosen.length === 0) {
                        // add checked new msisdn target
                        for (var i = 0; i < target.msisdn.length; i++) {
                            this.target_checked.push(target.id + '_' + target.msisdn[i])
                        }

                        this.target_choosen.push(target);

                    } else {
                        let index_data;
                        let search_target =  this.target_choosen.filter(function(item, index) {
                            if (item.id == target.id) {
                                index_data = index;
                                return item;
                            }
                        });

                        if (search_target.length > 0) {

                            // add checkbox if any data msisdn not saved in target
                            for (var j = 0; j < target.msisdn.length; j++) {

                                let index_checked = null;
                                let search_checked = this.target_checked.filter(function(item, index) {
                                    if (item === target.id + '_' + target.msisdn[j]) {
                                        index_checked = index;
                                        return item;
                                    }
                                });

                                if (search_checked.length > 0 && index_checked !== null) {
                                    this.target_checked[index_checked] = target.id + '_' + target.msisdn[j];
                                }
                            }

                            this.target_choosen[index_data] = target;

                            this.$swal.fire({
                                // icon: 'warning',
                                // title: 'Target '+ target.target_name +' already exist!',
                                icon: 'success',
                                title: 'Target '+ target.target_name +' updated!',
                            });
                        } else {
                            // add checked new msisdn target
                            for (var k = 0; k < target.msisdn.length; k++) {
                                this.target_checked.push(target.id + '_' + target.msisdn[k])
                            }

                            this.target_choosen.push(target);
                        }
                    }
                } else {
                    this.error("Target don't have MSISDN!");
                }
            } else {
                this.error("Target don't have MSISDN!");
            }

            if (this.target_keyword.length > 0) {
                this.target_keyword = '';
                this.single_target_list_data = [];
                this.page = 1;
                this.total_page = null;
                this.next_page = false;
                this.searchTarget();                
            } else {
                this.target_keyword = '';
            }
            if (document.getElementById('find-target-input'))
                document.getElementById('find-target-input').focus();
        },
        removeTarget(index) {
            for (var i = 0; i < this.target_choosen.length; i++) {
                if (index === i) {

                    // remove target checked if target removed
                    let target_remove = this.target_choosen[index];
                    for (var j = 0; j < target_remove.msisdn.length; j++) {
                        let index_checked = null;
                        let search_checked = this.target_checked.filter(function(item, index) {
                            if (item === target_remove.id + '_' + target_remove.msisdn[j]) {
                                index_checked = index;
                                return item;
                            }
                        });

                        if (search_checked.length > 0 && index_checked !== null) {
                            this.target_checked.splice(index_checked, 1);
                        }
                    }

                    this.target_choosen.splice(index, 1);
                }
            }
        },
        checkTargetMsisdn(e, target_id, msisdn) {
            let check_target = this.target_checked;
            check_target = check_target.filter(function(item) {
                let split_item = item.split('_');
                if (split_item[0] === target_id)
                    return item;
            });

            if (check_target.length === 0) {
                this.target_checked.push(target_id + '_' + msisdn);
                e.target.checked = true;

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Target need min 1 MSISDN!',
                    // allowOutsideClick: false,
                });
                // return;
            }
        },

        getData() {
            // console.log('=================== getData() route on roles form')

            this.group_name = '';
            // this.clues = [];
            // this.label = '';
            // this.status = '';
            // this.photo = '';
            this.case_id = [];
            this.target = '';
            this.additional_info = [];
            this.description = '';

            this.target_keyword = '';
            this.target_choosen = [];
            this.$store.commit('setSingleTargetList', {});

            // pagination target list
            this.single_target_list_data = [];
            this.page = 1;
            this.total_page = null;
            this.next_page = false;

            // this.photoFile= '';
            this.clueNameTmp= '';
            this.clueValTmp= '';
            this.infoNameTmp= '';
            this.infoValTmp= '';

            this.error_group_name = '';
            // this.error_clues = '';
            // this.error_label = '';
            // this.error_status = '';
            // this.error_photo = '';
            this.error_case_id = '';
            this.error_target = '';
            this.error_additional_info = '';
            this.error_description = '';
            
            // get client list
            if (this.route_name === 'PageMultiTrackingEdit' || this.route_name === 'PageMultiTrackingCreate') {

                // temporary
                // this.$store.dispatch('getClientsList', [100, 1]);

                // after client_id is not used
                this.$store.dispatch('getCaseManagementList', [100, 1]);
            }

            if (this.route_name === 'PageMultiTrackingEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);

                this.$store.dispatch('getMultiTrackingDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            } else {
                if (this.route_name === 'PageMultiTrackingCreate')
                    this.$store.commit('setMultiTrackingDetail', {});
            }
        },
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.photoFile = file
            this.photo = URL.createObjectURL(file);
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    if (this.route_name === 'PageMultiTrackingCreate') {
                        this.group_name = '';
                        // this.clues = [];
                        // this.label = '';
                        this.status = '';
                        // this.photo = '';
                        this.case_id = [];
                        this.description = '';
                        this.additional_info = [];

                        this.photoFile = '';
                        this.clueNameTmp = '';
                        this.clueValTmp = '';
                        this.infoNameTmp = '';
                        this.infoValTmp = '';

                        this.error_group_name = '';
                        // this.error_clues = '';
                        // this.error_label = '';
                        this.error_status = '';
                        // this.error_photo = '';
                        this.error_case_id = '';
                        this.error_description = '';
                        this.error_additional_info = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
        // submit(e){
            e.preventDefault();
            // console.log('=================== submit() route on roles form')
            // console.log(e);

            // console.log([this.group_name, this.clues, this.case_id, this.status, this.description]);
            // this.getData();

            this.showLoading(true);

            this.error_group_name = '';
            // this.error_clues = '';
            // this.error_label = '';
            this.error_status = '';
            // this.error_photo = '';
            this.error_case_id = '';
            this.error_target = '';
            this.error_description = '';
            this.error_additional_info = '';

            // console.log(this.clues.length)


            // validation
            if (this.group_name.length==0 || this.case_id.length==0 || this.target_choosen.length==0) {

                this.error_group_name = (this.group_name.length==0 ? 'Field target name is required.' : '');
                // this.error_label = (this.label.length==0 ? 'Field label is required.' : '');
                // this.error_status = (this.status.length==0 ? 'Field status is required.' : '');
                this.error_case_id = (this.case_id.length==0 ? 'Field operation name is required.' : '');
                this.error_target = (this.target_choosen.length==0 ? "Field target is required." : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: "Group name, operation name, target is required!",//+ (this.route_name === 'PageMultiTrackingCreate' ? ', status' : ', & status' ) +' is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.group_name.length>255) {

                this.error_group_name = (this.group_name.length>255 ? 'Field group name is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Group name is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            let target = JSON.parse(this.target);
            let target_choosen = this.target_choosen;
            let update_target_choosen = [];

            for (var i = 0; i < target_choosen.length; i++) {

                update_target_choosen[i] = target_choosen[i];

                if (target_choosen[i].id.length >  0) {
                    let target_choosen_id = target_choosen[i].id;
                    let target_checked = this.target_checked;
                    target_checked = target_checked.filter(function(item) {
                        let split_item_msisdn = item.split('_');
                        if (split_item_msisdn[0] === target_choosen_id)
                            return item;
                    });

                    if (target_checked.length > 0)
                        target_checked = Object.keys(target_checked).map((key) => target_checked[key].split('_')[1]);

                    // console.log(target_checked);
                    target[i].msisdn = target_checked
                } else {
                    target[i].name = target_choosen[i].target_name;

                    let msisdn = [];
                    for (var j = 0; j < target_choosen[i].msisdn.length; j++) {
                        // console.log(target_choosen[i].msisdn[j]);
                        if (target_choosen[i].msisdn[j] && target_choosen[i].msisdn[j].length > 0)
                            msisdn.push(target_choosen[i].msisdn[j]);
                    }

                    target[i].msisdn = msisdn;
                    // this.target_choosen[i].msisdn = msisdn;
                    update_target_choosen[i].msisdn = msisdn;
                }
            }

            this.target = JSON.stringify(target);
            this.target_choosen = update_target_choosen;

            // console.log(this.target);
            // console.log(this.target_choosen);
            // this.showLoading(false)
            // return;

            if (this.route_name === 'PageMultiTrackingCreate') {

                this.$store.dispatch('getMultiTrackingCreate', [this.group_name, [JSON.stringify(this.case_id)], this.target, [JSON.stringify(this.additional_info)], this.description])//this.status,
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageMultiTrackingIndex' });
                        if (save_continue === false) {
                            this.$router.push('/multi-tracking');
                        } else {
                            this.$router.push('/multi-tracking/'+ resp.data.data.id +'/edit');
                        }

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                    } else {
                        
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_group_name = (resp.data.message.errors.group_name ? resp.data.message.errors.group_name : '');
                            // this.error_clues = (resp.data.message.errors.clues ? resp.data.message.errors.clues : '');
                            // this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            // this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_case_id = (resp.data.message.errors.cases ? resp.data.message.errors.cases : '');
                            this.error_target = (resp.data.message.errors.target ? resp.data.message.errors.target : '');
                            this.error_additional_info = (resp.data.message.errors.additional_info ? resp.data.message.errors.additional_info : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(null, resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });

            // PageMultiTrackingEdit
            } else {

                this.$store.dispatch('getMultiTrackingUpdate', [this.id, this.group_name, [JSON.stringify(this.case_id)], this.target, [JSON.stringify(this.additional_info)], this.description])// this.status,
                .then((resp) => {
                    if (resp.result === 'success') {
                        if (save_continue === false)
                            this.$router.push('/multi-tracking');

                            // if (this.multi_tracking_redirect !== 'index') {
                            //     var msisdn = this.checkMsisdn(this.clues)
                            //     if (msisdn.length > 0) {
                            //         this.$router.push({ name: 'PageMultiTrackingDetailHome', params: { id: this.id ,key: encrypt(msisdn[0].value + '&&msisdn') }  })
                            //     } else {
                            //         this.$router.push('/multi-tracking');
                            //     }
                            // } else {
                            //     this.$router.push('/multi-tracking');
                            // }
                            

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_group_name = (resp.data.message.errors.group_name ? resp.data.message.errors.group_name : '');
                            // this.error_clues = (resp.data.message.errors.clues ? resp.data.message.errors.clues : '');
                            // this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            // this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_case_id = (resp.data.message.errors.cases ? resp.data.message.errors.cases : '');
                            this.error_target = (resp.data.message.errors.target ? resp.data.message.errors.target : '');
                            this.error_additional_info = (resp.data.message.errors.additional_info ? resp.data.message.errors.additional_info : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');

                            this.error(null, resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null, data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
        selectLabel(key) {
            this.label = key
        },
        // updateCase(value, id) {
        //     // console.log(value)
        //     // console.log(id)
        //     if (this.case_id.includes(value[0].id)) {
        //         // console.log('delete')
        //         // console.log(value[0].id)
        //         this.case_id = this.case_id.filter(id => id !== value[0].id);
        //     } else {            
        //         // console.log('update')
        //         // console.log(value[0].id)
        //         this.case_id.push({
        //             id: value[0].id
        //         })
        //     }
        // },
        addClue() {
            if (this.clueValTmp.length==0 || this.clueNameTmp.length==0) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Please fill in completely!',
                });

                return;
            }
            else {            
                this.clues.push({
                    name: this.clueNameTmp,
                    value: this.clueValTmp
                })
                this.clueNameTmp = ''
                this.clueValTmp = ''
            }
        },
        deleteClue(index) {
            this.clues.splice(index, 1);
        },
        addInfo() {
            if (this.infoValTmp.length==0 || this.infoNameTmp.length==0) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Please fill in completely!',
                });

                return;
            }
            else {            
                this.additional_info.push({
                    name: this.infoNameTmp,
                    value: this.infoValTmp
                })
                this.infoNameTmp = ''
                this.infoValTmp = ''
            }
        },
        deleteInfo(index) {
            this.additional_info.splice(index, 1);
        }
    },
    mounted() {
        // console.log('=================== mounted on single target form')
        // this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
        this.getData();
    },
    // destroyed() {
    //     this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
    // },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="sass">
    .main-target-lists
        ul
            max-height: 300px
            overflow: auto
</style>


